import { BoxInput } from '../types/form';

export const isPhoneMaskedValid = (val: string) => val?.length === 15;

export const areBoxesValid = (inputs: BoxInput[]) =>
    inputs.every(i => i.length > 0 && i.width > 0 && i.height > 0 && i.amount > 0);
